import { Typography, Box, Paper, Grid } from '@mui/material';
import { BooleanInput } from 'react-admin';
import { useWatch, useFormContext } from 'react-hook-form';
import { useEffect } from 'react';

function SapsfConfigEditor() {
  const { setValue } = useFormContext();
  const importHb = useWatch({ name: 'config.importHb' });

  // When importHb is turned off, set considerHBImportInHoursBankLimits to false
  useEffect(() => {
    if (!importHb) {
      setValue('config.considerHBImportInHoursBankLimits', false);
    }
  }, [importHb, setValue]);

  return (
    <Box>
      <Grid container spacing={3}>
        {/* Additional Options */}
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Additional Options
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <BooleanInput source="config.importHb" label="Import HB" />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <BooleanInput source="config.considerHBImportInHoursBankLimits" label="Consider HB Import in Hours Bank Limits" disabled={!importHb} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SapsfConfigEditor;
